// extracted by mini-css-extract-plugin
module.exports = {"Modal_container":"ModalResponsive_Modal_container__l6sJ6","Title":"ModalResponsive_Title__28W6d"};